module.exports = __webpack_public_path__ + "static/metaScreenshot-6c42f4d5ddd1ff8f1c47df1147078958.png";